import React from 'react'

import { useBackButton } from '../BackButton'
import { NavbarBackButtonItem } from '../EmbeddedDetailHeader/EmbeddedDetailHeader.styles'
import BackButton from '../BackButton/BackButton'
import { useForTablet } from '@sketch/components'

/**
 * This component acts as a wrapper to run useBackButton hook only when
 * BackButton needs to be rendered. By doing that, DocumentSidebarLayout can
 * be rendered outside ShareViewsNavigationContextProvider and ShareVersionProvider contexts.
 */
export const LayoutHeaderBackButton = () => {
  const isTabletAndBigger = useForTablet()
  const { link: shouldRenderBackButton } = useBackButton()

  return isTabletAndBigger && shouldRenderBackButton ? (
    <NavbarBackButtonItem>
      <BackButton />
    </NavbarBackButtonItem>
  ) : null
}
